import React, { useState } from 'react';
import './App.css';
import { fetchApi } from 'utils/fetch-api';
import { config } from 'utils/config';
import { Box, Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    error: {
        color: 'red'
    }
}));

type ButtonAPICommandProps = {
    buttonLabel: string;
    endpoint: string;
    method?: string;
    loadingButtonLabel: string;
    errorText?: string;
};

export default function ButtonAPICommand(props: ButtonAPICommandProps) {
    const {
        buttonLabel,
        endpoint,
        method = 'POST',
        loadingButtonLabel,
        errorText = 'An error occurred while performing the action.'
    } = props;

    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnText, setBtnText] = useState<any>(buttonLabel);
    const [errorMsg, setErrorMsg] = useState('');
    const classes = useStyles();

    const handleClick = () => {
        setBtnDisabled(true);
        setBtnText(loadingButtonLabel);

        fetchApi(
            config.get().apiBaseURL + endpoint,
            { method },
            (_data: any) => {
                setBtnText(buttonLabel);
            },
            () => {
                setErrorMsg(errorText);
                return Promise.resolve();
            }
        );
    };

    return (
        <Box>
            <p className={classes.error}>{errorMsg}</p>
            <Button
                fullWidth
                variant="contained"
                color="secondary"
                className={classes.submit}
                disabled={btnDisabled}
                onClick={handleClick}
            >
                {btnText}
            </Button>
        </Box>
    );
}
